import {useRouter} from "next/router";
import PropTypes from "prop-types";
import Image from "next/image";
import getAbsUrl from "../utils/getAbsUrl";

const SocialBlock = ({isBottom = false}) => {
  const { basePath, asPath, locale: currentLocale } = useRouter();
  const urlShareFacebook = 'https://www.facebook.com/sharer/sharer.php';
  const urlShareTwitter = 'https://twitter.com/intent/tweet';
  const urlShareLinkedin = 'https://www.linkedin.com/shareArticle';
  const sharedUrl = encodeURI(getAbsUrl(asPath));
  const url = currentLocale !== 'en' ? sharedUrl.replace('/blog', `/${currentLocale}/blog`) : sharedUrl

  return (
    <div className='social-block'>
      <a
        className='social-block__link'
        href={`${urlShareFacebook}?u=${url}`}
        target="_blank"
        rel="noreferrer"
      >
        <Image src={`${basePath}/images/facebook.svg`} width={isBottom ? 48 : 32} height={isBottom ? 48 : 32} alt=""/>
      </a>
      <a
        className='social-block__link'
        href={`${urlShareTwitter}?text=${url}`}
        target="_blank"
        rel="noreferrer"
      >
        <Image src={`${basePath}/images/twitter.svg`} width={isBottom ? 48 : 32} height={isBottom ? 48 : 32} alt=""/>
      </a>
      <a
        className='social-block__link'
        href={`${urlShareLinkedin}?mini=true&url=${url}`}
        target="_blank"
        rel="noreferrer"
      >
        <Image src={`${basePath}/images/linkedin.svg`} width={isBottom ? 48 : 32} height={isBottom ? 48 : 32} alt=""/>
      </a>
    </div>
  )
}

SocialBlock.propTypes = {
  isBottom: PropTypes.bool,
};

export default SocialBlock;
